module.exports = __webpack_public_path__ + "img/gerenxinxi.ab4cf9d3.png";